import { ProductSettings } from '@buy/state/product-settings'

export const productSettingsInitialData: ProductSettings = {
    abandonmentProgram: '',
    analyticsContainerID: '',
    adminUrl: '',
    productPortalUrl: '',
    favicon: '',
    logo: '',
    logoMobile: '',
    logoUrl: '',
    platformProduct: '',
    enablePlanCustomization: false,
    enableChatBot: false,
    productFamily: '',
    qualtricsProductName: '',
    theme: '',
    currencySettings: [],
}
